import React from "react";
import InfoIcon from "../../images/i.svg"

export default ({ children }) => (
    <div className='metadata--container'>
        <InfoIcon/>
        <div className='metadata' style={{width: "100%"}}>{children}</div>
    </div>
);



// WEBPACK FOOTER //
// ./src/components/info.js